import { Document } from '@react-pdf/renderer';

import { Page } from '../../../../components/PdfExportV2/Page/Page.tsx';
import { COMMENTARY_TEXT } from '../../consts.ts';
import { ExportCommentarySection } from '../ExportCommentarySection.tsx';
import { ExportCostApproachDataSources } from './ExportCostApproachDataSources.tsx';
import { ExportCostApproachTable } from './ExportCostApproachTable.tsx';
import { ExportManufacturedCostApproachTable } from './ExportManufacturedCostApproachTable/ExportManufacturedCostApproachTable.tsx';
import { ExportCostApproachData } from './types.ts';

export const ExportCostApproach = ({
  data,
  subjectAddress,
  hasExternalDepreciation,
  hasFunctionalDepreciation,
}: {
  data: ExportCostApproachData;
  subjectAddress: string;
  hasExternalDepreciation: boolean;
  hasFunctionalDepreciation: boolean;
}) => {
  return (
    <Document>
      <Page title="">
        <ExportCommentarySection
          subjectAddress={subjectAddress}
          {...COMMENTARY_TEXT['cost-approach']}
        >
          {data.propertyType === 'manufacturedHome' && data.manufacturedTableData ? (
            <ExportManufacturedCostApproachTable tableData={data.manufacturedTableData} />
          ) : (
            <ExportCostApproachTable
              data={data}
              hasExternalDepreciation={hasExternalDepreciation}
              hasFunctionalDepreciation={hasFunctionalDepreciation}
            />
          )}
          <ExportCostApproachDataSources data={data} />
        </ExportCommentarySection>
      </Page>
    </Document>
  );
};
